<template>
  <main :class="$store.getters['event/event'].theme_color">
    <router-view />
  </main>
</template>

<script>
export default {
  name: "LoginBase",
  computed: {
    event() {
      return this.$store.getters["event/event"]
    }
  }
}
</script>

<style scoped></style>
